import React, { useCallback } from "react";
import "./ChatOptions.css";
import { NewChatOptions } from "../../../../utils/data";
import { Option } from "../option/Option";
import BookCourtChat from "../../../../assets/book-court-chat.png";
import CancelBookingChat from "../../../../assets/cancel-booking-chat.png";
import CheckRainChat from "../../../../assets/check-rain-chat.png";
import CoachInfoChat from "../../../../assets/coach-info-chat.png";
import NextAvailableCourt from "../../../../assets/next-available-court-chat.png";
import PlayableCourt from "../../../../assets/payable-court-chat.png";
import { NewChatOptionType } from "../../../../types/types";

type props = {
  onPress: (chat: NewChatOptionType) => void;
};

export const ChatOptions: React.FC<props> = ({ onPress }) => {
  const getOptionImage = useCallback((chat: NewChatOptionType) => {
    switch (chat.id) {
      case 1:
        return BookCourtChat;
      case 2:
        return CancelBookingChat;
      case 3:
        return CoachInfoChat;
      case 4:
        return PlayableCourt;
      case 5:
        return NextAvailableCourt;
      case 6:
        return CheckRainChat;
      default:
        return BookCourtChat;
    }
  }, []);

  return (
    <div className="chat-options-container">
      {NewChatOptions.map((chat, index) => (
        <Option
          onClick={() => {
            onPress(chat);
          }}
          key={chat.id}
          title={chat.label}
          image={getOptionImage(chat)}
        />
      ))}
    </div>
  );
};
